export default "__VITE_ASSET__DToTCYGX__"